var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Serve",on:{"click":_vm.open}},[_c('el-avatar',{staticClass:"Serve-header",attrs:{"size":40,"src":_vm.circleUrl}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("客服"),_c('br'),_vm._v("信息")])
}]

export { render, staticRenderFns }